module.exports = __webpack_public_path__ + "assets/img/coupon.de915746.svg";